import { render, staticRenderFns } from "./InterestRewardEditor.vue?vue&type=template&id=087667f6&scoped=true"
import script from "./InterestRewardEditor.vue?vue&type=script&lang=ts"
export * from "./InterestRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087667f6",
  null
  
)

export default component.exports